import React, { useContext, useMemo, useCallback, useRef } from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";

interface GoogleMapsWrapperProps {
  apiKey: string;
}

type ContextValue = {
  status: React.MutableRefObject<Status>;
};

const GoogleMapsWrapperContext = React.createContext<ContextValue | undefined>(
  undefined
);

export const GoogleMapsWrapperProvider: React.FC<GoogleMapsWrapperProps> = (
  props
) => {
  const status = useRef<Status>(Status.LOADING);

  const render = useCallback(
    (currentStatus: Status) => {
      status.current = currentStatus;

      return <>{props.children}</>;
    },
    [props.children]
  );

  const value = useMemo(() => ({ status: status }), [status]);

  return (
    <GoogleMapsWrapperContext.Provider value={value} {...props}>
      {props.apiKey ? (
        <Wrapper apiKey={props.apiKey} render={render} />
      ) : (
        <>{props.children}</>
      )}
    </GoogleMapsWrapperContext.Provider>
  );
};

export const useGoogleMapsWrapper = (): ContextValue => {
  const context = useContext(GoogleMapsWrapperContext);
  if (context === undefined) {
    throw new Error(
      "useGoogleMapsWrapper must be used within an GoogleMapsWrapperProvider"
    );
  }
  return context;
};
